import { useEffect, useState } from "react";
import { Copy, Save, Pencil, X } from "lucide-react";
import Api from "../../../../shared/api/api";
import { useSettings } from "../../context/SettingsContext";
import "../styles/AdminSettings.css";

const text = value => typeof value === "object" ? JSON.stringify(value) : String(value ?? "");
export default function Settings() {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [editField, setEditField] = useState(null);
  const [draft, setDraft] = useState("");
  const [busy, setBusy] = useState(false);
  const { refreshSettings } = useSettings();
  useEffect(() => {
    let active = true;
    Api.getSettings().then(result => { if (active) setSettings(result.settings || {}); }).catch(err => { if (active) setError(err.message); }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);
  async function save(key) {
    setBusy(true); setError(""); setMessage("");
    try {
      const previous = settings[key];
      let value = draft;
      if (typeof previous === "number") { value = Number(draft); if (!draft.trim() || !Number.isFinite(value)) throw new Error("Enter a valid number."); }
      else if (typeof previous === "object" && previous !== null) value = JSON.parse(draft);
      await Api.updateSettings({ [key]: value });
      setSettings(current => ({ ...current, [key]: value })); setEditField(null); setMessage("Setting saved.");
      await refreshSettings();
    } catch (err) { setError(err.message || "Could not save setting."); } finally { setBusy(false); }
  }
  async function copy(value) {
    try { await navigator.clipboard.writeText(text(value)); setMessage("Setting copied."); }
    catch { setError("Clipboard unavailable."); }
  }
  return <div className="adminPageContainer settings-page"><h1>Settings</h1>
    {loading && <p role="status">Loading settings...</p>}{error && <p role="alert">{error}</p>}{message && <p role="status">{message}</p>}
    {!loading && <section className="formSection">{Object.entries(settings).sort(([a], [b]) => a.localeCompare(b)).map(([key, value]) => <div className="settingRow" key={key}>
      <label className="settingKey" htmlFor={`setting-${key}`}>{key}</label>
      {editField === key ? typeof value === "boolean" ? <input id={`setting-${key}`} type="checkbox" checked={draft === true} onChange={event => setDraft(event.target.checked)} /> : typeof value === "object" && value !== null ? <textarea id={`setting-${key}`} className="settingInput" value={draft} onChange={event => setDraft(event.target.value)} rows={4} /> : <input id={`setting-${key}`} type={typeof value === "number" ? "number" : "text"} step="any" className="settingInput" value={draft} onChange={event => setDraft(event.target.value)} /> : <div className="settingValue" title={text(value)}>{text(value)}</div>}
      <div className="settingActions"><button type="button" title="Copy setting" aria-label={`Copy ${key}`} disabled={busy} onClick={() => copy(value)}><Copy size={17} /></button>
        {editField === key ? <><button type="button" title="Save setting" aria-label={`Save ${key}`} disabled={busy} onClick={() => save(key)}><Save size={17} /></button><button type="button" title="Cancel edit" disabled={busy} onClick={() => setEditField(null)}><X size={17} /></button></> : <button type="button" title="Edit setting" aria-label={`Edit ${key}`} disabled={busy} onClick={() => { setEditField(key); setDraft(typeof value === "boolean" ? value : text(value)); }}><Pencil size={17} /></button>}
      </div></div>)}{!Object.keys(settings).length && !error && <p>No settings found.</p>}</section>}
  </div>;
}
